import styled from 'styled-components';

// @ts-ignore
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

export const breakePoints = {
    lDesktop: '1600px',
    desktop: '1599px',
    sDesktop: '1365px',
    laptop: '1279px',
    tablet: '1023px',
    mobile: '767px',
    sMobile: '479px',
};

export const InternetRepresent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

export const StyledGridContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    @media (max-width: ${breakePoints.desktop}) {
        padding-left: 0;
        padding-right: 0;
    }

    @media (max-width: ${breakePoints.mobile}) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;

export const PlankFormWrap = styled.div`
    position: fixed;
    z-index: 100;
    bottom: 0;
    width: 100%;

    @media (max-width: ${breakePoints.mobile}) {
        display: none;
    }
`;
